var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrowthsAndDev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95.034,
    height: 95.034,
    viewBox: "0 0 95.034 95.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke-miterlimit:10;}.b,.c{stroke:#fff;stroke-width:2px;}.c{fill:url(#a);}.d{clip-path:url(#d);}.e{filter:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8f00"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0,
    y: 0,
    width: 95.034,
    height: 95.034,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1102.519,98.855",
    transform: "translate(-1102.519 -98.855)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1016.036 -51.447)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 37.517,
    cy: 37.517,
    r: 37.517,
    transform: "translate(1016.036 51.447)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1016.036 51.447)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(1, 0, 0, 1, -10, -7)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 37.517,
    cy: 37.517,
    r: 37.517,
    transform: "translate(10 7)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.351 15.523)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.492 40.611)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1084.935,98.975",
    transform: "translate(-1084.935 -98.975)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.743 40.507)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1102.519,98.855",
    transform: "translate(-1102.519 -98.855)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1102.519,98.855Z",
    transform: "translate(-1102.519 -98.855)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1102.519,98.855Z",
    transform: "translate(-1102.519 -98.855)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1102.519,98.855Z",
    transform: "translate(-1102.519 -98.855)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1102.519,98.855Z",
    transform: "translate(-1102.519 -98.855)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1102.519,98.855",
    transform: "translate(-1102.519 -98.855)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1112.936,88.774h-5.606V57.756H1086.9a2.671,2.671,0,0,0-2.687,2.649V88.774H1078.6V60.405a8.283,8.283,0,0,1,8.293-8.254h22.463a3.578,3.578,0,0,1,3.577,3.572Z",
    transform: "translate(-1078.603 -52.151)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 29.205)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1112.936,101.281H1086.29a7.7,7.7,0,0,1-7.687-7.687v-.083a7.7,7.7,0,0,1,7.687-7.687h26.646ZM1086.29,91.43a2.083,2.083,0,0,0-2.081,2.081v.083a2.083,2.083,0,0,0,2.081,2.081h21.04V91.43Z",
    transform: "translate(-1078.603 -85.824)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.839 8.896)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 14.766,
    transform: "translate(1.869 1.868)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1103.123,66.145h-14.766a1.869,1.869,0,1,1,0-3.737h14.766a1.869,1.869,0,0,1,0,3.737Z",
    transform: "translate(-1086.488 -62.408)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.839 13.78)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.229,
    transform: "translate(1.869 1.869)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1099.586,71.776h-11.229a1.869,1.869,0,1,1,0-3.737h11.229a1.869,1.869,0,0,1,0,3.737Z",
    transform: "translate(-1086.488 -68.039)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthsAndDev);
export default __webpack_public_path__ + "static/media/growths-and-dev.73822c0cd0c13bd3f6b35c9d147af19c.svg";
export { ForwardRef as ReactComponent };